<div class="delegation-empty-card flex-col justify-center items-center gap-10">
    <div class="delegation-empty-card-icon justify-center items-center">
        <mat-icon svgIcon="delegate"></mat-icon>
    </div>
    @if (isChildProfile$ | async) {
        <nova-delegation-restrict-access></nova-delegation-restrict-access>
    } @else {
        <div class="delegation-empty-card-message flex-col justify-center items-center">You have no delegations assigned to you</div>
    }
</div>
